<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <div class="searchItem">
                            <el-input
                                v-model="activityName"
                                placeholder="活动名称"
                            ></el-input>
                        </div>
                        <div class="searchItem">
                            <el-select
                                v-model="status"
                                clearable
                                placeholder="作品审核状态"
                            >
                                <el-option label="审核中" value="SUBMIT"
                                    >审核中</el-option
                                >
                                <el-option label="未通过" value="REJECT"
                                    >未通过</el-option
                                >
                                <el-option label="已通过" value="PASS"
                                    >已通过</el-option
                                >
                            </el-select>
                        </div>
                        <div class="searchItem">
                            <el-select
                                v-model="activityStatus"
                                clearable
                                placeholder="活动状态"
                            >
                                <el-option label="征集中" value="COLLECT"
                                    >征集中</el-option
                                >
                                <el-option label="评选中" value="EVALUATE"
                                    >评选中</el-option
                                >
                                <el-option label="已结束" value="FINISHED"
                                    >已结束</el-option
                                >
                            </el-select>
                        </div>
                        <div class="searchItem">
                            <el-select
                                v-model="isAward"
                                clearable
                                placeholder="获奖情况"
                            >
                                <el-option label="全部" value=""
                                    >全部</el-option
                                >
                                <el-option label="已获奖" value="true"
                                    >已获奖</el-option
                                >
                                <el-option label="未获奖" value="false"
                                    >未获奖</el-option
                                >
                            </el-select>
                        </div>
                        <el-button class="searchBtn" @click="search"
                            >搜索</el-button
                        >
                        <el-button
                            type="text"
                            class="resetBtn"
                            @click="resetData"
                        >
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>
                    </div>
                    <div class="orderListTable">
                        <el-table
                            :data="tableData"
                            :span-method="objectSpanMethod"
                            border
                            style="width: 100%"
                            class="tableContent"
                        >
                            <el-table-column
                                prop="activityName"
                                label="活动名称"
                                header-align="center"
                                show-overflow-tooltip
                                align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="activityCollectEndTime"
                                label="作品征集截止时间"
                                header-align="center"
                                show-overflow-tooltip
                                align="center"
                            >
                                <template slot-scope="scope">
                                    {{
                                        timeDate(
                                            scope.row.activityCollectEndTime
                                        )
                                    }}
                                    <!--{{ timeDate(scope.row.activityCollectStartTime) }}
                                    -{{ timeDate(scope.row.activityCollectEndTime) }}-->
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="activityWayName"
                                label="赛道名称"
                                header-align="center"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    <el-tooltip class="item" effect="dark" :content="scope.row.activityWayName" placement="top-start">
                                        <p class="clamp—one">{{ scope.row.activityWayName }}</p>
                                    </el-tooltip>
                                    <el-button
                                        type="text"
                                        size="small"
                                        v-if="scope.row.activityStatus === 'COLLECT'"
                                        @click="toEditInfo(scope.row, 'add')"
                                    >上传作品</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="worksName"
                                label="作品名称"
                                header-align="center"
                                show-overflow-tooltip
                                align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="worksCode"
                                label="作品编号"
                                header-align="center"
                                show-overflow-tooltip
                                align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="typeName"
                                label="作品类型"
                                header-align="center"
                                show-overflow-tooltip
                                align="center"
                            >
                                <template slot-scope="scope">
                                    {{
                                        scope.row.typeName == null
                                            ? ""
                                            : scope.row.typeName
                                    }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="worksUploadTime"
                                align="center"
                                show-overflow-tooltip
                                header-align="center"
                                label="作品上传时间"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="examineTime"
                                align="center"
                                header-align="center"
                                show-overflow-tooltip
                                label="作品审核时间"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="worksStatus"
                                align="center"
                                header-align="center"
                                label="审核状态"
                            >
                                <template slot-scope="scope">
                                    {{
                                        scope.row.worksStatus === null
                                            ? ""
                                            : scope.row.worksStatus === "SUBMIT"
                                            ? "审核中"
                                            : scope.row.worksStatus === "PASS"
                                            ? "已通过"
                                            : "未通过"
                                    }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="score"
                                align="center"
                                header-align="center"
                                label="获奖情况"
                            >
                                <template slot-scope="scope">
                                    {{
                                        scope.row.activityStatus !== "FINISHED"
                                            ? ""
                                            : scope.row.awardName == null
                                            ? "未获奖"
                                            : scope.row.awardName
                                    }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                header-align="center"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    <!-- <el-button type="text" size="small" v-if="scope.row.worksStatus===null&&scope.row.activityStatus==='COLLECT'" @click="toEditInfo(scope.row,'add')">上传作品</el-button> -->
                                    <!--<el-button
                                        type="text"
                                        size="small"
                                        v-if="
                                            scope.row.worksStatus !== null &&
                                                scope.row.worksStatus !==
                                                    'PASS' &&
                                                scope.row.activityStatus ===
                                                    'COLLECT'
                                        "
                                        @click="toEditInfo(scope.row, 'edit')"
                                        >编辑作品</el-button
                                    >-->
                                    <el-button
                                        type="text"
                                        size="small"
                                        v-if="
                                            scope.row.worksStatus !== null &&
                                                scope.row.worksStatus ==
                                                    'REJECT'
                                        "
                                        @click="toEditInfo(scope.row, 'edit')"
                                    >编辑作品</el-button>
                                    <el-button
                                        type="text"
                                        size="small"
                                        v-if="scope.row.worksStatus !== null"
                                        @click="
                                            getWorksDetails(scope.row.worksUuid)
                                        "
                                        >查看作品</el-button>
                                    <el-button
                                        type="text"
                                        size="small"
                                        v-if="scope.row.worksStatus ==='PASS' && scope.row.worksUuid !== null"
                                        @click="
                                            showQualification(scope.row)
                                        "
                                    >{{
                                        scope.row.qualificationUrl!==null?"重新上传":"上传资质"
                                        }}</el-button>
                                    <el-button
                                        type="text"
                                        size="small"
                                        v-if="scope.row.certificateUrl"
                                        @click="
                                            downLoadCertificate(scope.row.certificateUrl,scope.row.certificateName)
                                        "
                                    >下载证书</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total"
                            class="pagination"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <!--编辑-->
        <el-dialog
            :title="worksTitle"
            :visible.sync="driDialog"
            v-if="driDialog"
            :close-on-click-modal="false"
            width="800px"
        >
            <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
            >
                <el-form-item label="作品名称" prop="name">
                    <el-input
                        v-model="ruleForm.name"
                        maxlength="50"
                        show-word-limit
                    ></el-input>
                </el-form-item>
                <el-form-item label="作品类别" prop="typeUuid">
                    <el-select v-model="ruleForm.typeUuid" placeholder="请选择">
                        <el-option
                            v-for="item in typeList"
                            :key="item.uuid"
                            :label="item.worksType"
                            :value="item.uuid"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="作品简介" prop="summary">
                    <el-input
                        type="textarea"
                        v-model="ruleForm.summary"
                        maxlength="250"
                        show-word-limit
                    ></el-input>
                </el-form-item>
                <el-form-item label="作品封面" prop="coverUrl">
                    <div style="display: flex;" class="upload_imgbox">
                        <el-upload
                            action="/service-center/upload/file/single"
                            :on-remove="handleRemove"
                            accept="image/*"
                            :on-progress="handleProgress"
                            :on-success="handleCoverSuccess"
                            :headers="headers"
                            :file-list="ruleForm.coverName"
                            :show-file-list="false"
                        >
                            <div
                                class="upload_imgboxText"
                                v-if="!ruleForm.coverUrl"
                            >
                                <i class="el-icon-upload2"></i>
                                <p>上传参赛作品封面</p>
                            </div>
                            <img
                                :src="ruleForm.coverUrl"
                                alt=""
                                v-if="ruleForm.coverUrl"
                                class="imgurl"
                            />
                        </el-upload>
                    </div>
                    <p class="imgsMess">请上传274*171的图片</p>
                </el-form-item>
                <el-form-item label="作品说明" prop="description">
                    <tinymce
                        v-model="ruleForm.description"
                        @input="editHomepageInput2"
                    ></tinymce>
                </el-form-item>
                <el-form-item label="参赛作品" prop="worksFileList">
                    <el-upload
                        class="upload-demo"
                        ref="upload"
                        action="/service-center/upload/file/single"
                        :on-progress="handleProgress"
                        :on-remove="handleRemove"
                        :on-success="handleWorksSuccess"
                        :headers="headers"
                        :file-list="ruleForm.worksFileList"
                    >
                        <el-button size="small" type="primary"
                            >上传参赛作品</el-button
                        >
                    </el-upload>
                    <p class="imgsMess">
                        ①须上传符合大赛模板的展板（模板于报名指南最下方下载，上传格式支持JPG&PNG)  <br>
                        ②须上传STL格式的模型文件（大小不超过100M)
                    </p>
                </el-form-item>
                <el-form-item
                    label="驳回原因"
                    v-if="ruleForm.status === 'REJECT'"
                >
                    {{ ruleForm.remark }}
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="updateUploadWorks()"
                        >提交</el-button
                    >
                    <el-button @click="driDialog = false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="资质上传" :visible.sync="qualificationDialog" v-if="qualificationDialog" :close-on-click-modal="false" width="500px">
            <el-form
                :model="qualificationForm"
                :rules="qualificationRules"
                ref="qualificationForm"
                label-width="100px"
                class="demo-ruleForm"
            >
                <el-form-item label="资质文件" prop="url">
                    <el-upload
                        class="upload-demo"
                        ref="upload"
                        accept=".zip"
                        action="/service-center/upload/file/single"
                        :on-success="handleQualificationSuccess"
                        :headers="headers"
                        :file-list="qualificationForm.url"
                        :show-file-list="false"
                    >
                        <el-button size="small" type="primary"
                        >上传资质文件</el-button
                        >
                    </el-upload>
                    <p class="imgsMess">
                        请压缩成zip文件上传
                    </p>
                </el-form-item>
                <el-form-item label="资质名称" prop="name">
                    <el-input
                        v-model="qualificationForm.name"
                        maxlength="50"
                        show-word-limit
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="uploadQualification()"
                    >提交</el-button
                    >
                    <el-button @click="qualificationDialog = false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- 查看 -->
        <works-details-dialog
            ref="worksDetailsDialogRef"
        ></works-details-dialog>
    </div>
</template>

<script>
    import { getActivityTypeList, getSignWorksList,
        getViewUploadWorks, updateUploadWorks, addActivityWorks,getWorksQualification,addWorksQualification } from '../../utils/interface';
    ///
    import tinymce from '@/components/tinymce'
    // 查看
    import worksDetailsDialog from './worksDetailsDialog'
    export default {
        data() {
            return {
                activityName: '',
                status:'',
                activityStatus: '',
                isAward:'',
                // 排序
                checkboxGroup: {
                    radio1: '0',
                },
                tableData:[],
                current: 1,
                pageSize: 10,
                total: 0,
                driDialog:false,
                qualificationDialog:false,
                worksUuid: "",
                worksTitle:"",
                ruleForm: {
                    uuid:'',
                    summary: '',
                    name:'',
                    coverUrl: '',
                    coverName: [],
                    worksUrl: '',
                    //worksName: [],
                    videoUrl: '',
                    //videoName: [],
                    description:'',
                    typeUuid: '',
                    activityWayUuid: '',
                    worksFileList:[]
                },
                qualificationForm:{
                    worksUuid: '',
                    name: '',
                    url: ''
                },
                qualificationRules: {
                    name: [
                        { required: true, message: '请输入资质名称', trigger: 'blur' },
                    ],
                    url:[
                        { required: true, validator:this.validateQualificationFileUrl,  trigger:["change"] },
                    ]
                },
                rules: {
                    name: [
                        { required: true, message: '请输入作品名称', trigger: 'blur' },
                    ],
                    /*typeUuid: [
                        { required: true, message: '请选择作品类别', trigger: 'change' },
                    ],*/
                    summary: [
                        { required: true, message: '请输入作品简介', trigger: 'blur' },
                    ],
                    coverUrl: [
                        { required: true, message: '上传作品封面', trigger: 'blur' },
                    ],
                    description: [
                        { required: true, message: '请输入作品说明', trigger: 'blur' },
                    ],
                    worksFileList:[
                        { required: true, validator:this.validateFileUrl,  trigger:["change"] },
                    ]
                },
                headers: {
                    'Authorization': 'Bearer ' + this.$cookies.get("api_access_token")	//	可以是授权凭证用的参数值
                },
                typeList:[],
                type:"",
                spanArr:[],
                spanArr2:[],
            }
        },
        computed: {
            contentViewHeight() {
                let height = document.documentElement.clientHeight - 120
                return {minHeight: height + 'px'}
            },
        },
        components: {
            tinymce,
            worksDetailsDialog
        },
        created() {
            this.getList();
        },
        methods: {
            validateFileUrl(rule, value, callback){
                if(value.length==0){
                    callback(new Error("请上传文件"))
                }else{
                    callback()
                }
            },
            validateQualificationFileUrl(rule, value, callback) {
                if(value.length==0){
                    callback(new Error("请上传资质文件"))
                }else{
                    callback()
                }
            },
            getList(){
                let params = {
                    activityName:this.activityName,
                    worksStatus:this.status,
                    activityStatus:this.activityStatus,
                    isAward:this.isAward,
                    //isBuy:true,
                    current:this.current,
                    pageSize:this.pageSize,
                };
                getSignWorksList(params).then((res)=>{
                    this.total = res.total;
                    this.tableData = res.list;
                    this.spanArr = [];
                    this.spanArr2 = [];
                    this.getSpanArr(this.tableData);
                });

            },
            getSpanArr(data) {
                // data就是我们从后台拿到的数据
                for (let i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr.push(1);
                        this.spanArr2.push(1);
                        this.pos = 0;
                        this.pos2 = 0;
                    } else {
                        // 判断当前元素与上一个元素是否相同
                        if (data[i].activityUuid === data[i - 1].activityUuid) {
                            this.spanArr[this.pos] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.pos = i;
                            this.spanArr.push(1);
                        }
                        if(data[i].activityWayUUid == data[i - 1].activityWayUUid ){
                            this.spanArr2[this.pos2] += 1;
                            this.spanArr2.push(0);
                        }else {
                            this.pos2 = i;
                            this.spanArr2.push(1);
                        }
                    }
                }
            },
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                if (columnIndex === 0 || columnIndex === 1) {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    };
                } else if(columnIndex === 2){
                    const _row = this.spanArr2[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    };
                }
            },
            resetData(){
                this.activityName = '';
                this.activityStatus = '';
                this.status = '';
                this.isAward = '';
                this.search();
            },
            // 分页
            handleCurrentChange(val){
                this.current = val;
                this.getList();
            },
            search(){
                this.current = 1;
                this.getList();
            },
            // 编辑
            toEditInfo(item,type){
                this. ruleForm = {
                    uuid:'',
                    summary: '',
                    name:'',
                    coverUrl: '',
                    coverName: [],
                    worksUrl: '',
                    videoUrl: '',
                    description:'',
                    typeUuid: '',
                    activityWayUuid: '',
                    worksFileList:[]
                }
                this.$nextTick(() => {
                    // DOM 更新了
                    this.$refs["ruleForm"].clearValidate()
                });
                this.type = type;
                if(type=='add'){
                    this.worksTitle = "上传作品";
                    this.ruleForm.activityWayUuid = item.activityWayUUid;
                    this.ruleForm.activityUuid = item.activityUuid;
                }else if(type=='edit'){
                    this.worksTitle = "编辑作品";
                    getViewUploadWorks(item.worksUuid).then((res)=>{
                        if(res!==''){
                            this.ruleForm.uuid = res.uuid;
                            this.ruleForm.activityWayUuid = res.activityWayUuid;
                            this.ruleForm.typeUuid = res.typeUuid;
                            this.ruleForm.name = res.name;
                            this.ruleForm.summary = res.summary;
                            this.ruleForm.description = res.description;
                            this.ruleForm.coverUrl = res.coverUrl;
                            this.ruleForm.worksUrl = res.worksUrl;
                            this.ruleForm.videoUrl = res.videoUrl;
                            //this.ruleForm.videoName = res.videoName;
                            //this.ruleForm.worksName = res.worksName;
                            this.ruleForm.activityUuid = res.activityUuid;
                            this.ruleForm.worksFileList = res.worksFileList;
                            this.ruleForm.status = res.status;
                            this.ruleForm.remark = res.remark;
                        }
                    });
                }
                getActivityTypeList({activityWayUuid: item.activityWayUUid}).then((res)=>{
                    this.typeList = res.data;
                });
                this.driDialog = true;
            },
            // 编辑
            updateUploadWorks(){
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        if(this.type=='add'){
                            addActivityWorks(this.ruleForm).then((res)=>{
                                if (res.success) {
                                    this.driDialog = false;
                                    this.$message.success("上传成功");
                                    // this.search();
                                    this.getList();

                                }
                            });
                        }else{
                            updateUploadWorks(this.ruleForm).then((res)=>{
                                if (res.success) {
                                    this.driDialog = false;
                                    this.$message.success("编辑成功");
                                    this.getList();
                                    // this.search();
                                }else{
                                    this.$message.error(res.message);
                                }
                            });
                        }
                    }
                });
            },
            // // 查看
            getWorksDetails(uuid){
                this.$refs.worksDetailsDialogRef.init(uuid);
            },
            showQualification(row) {
                this.qualificationForm={
                    worksUuid:row.worksUuid,
                    name: '',
                    url: ''
                };
                if(row.qualificationUuid){
                    getWorksQualification(row.qualificationUuid).then(resp=>{
                        if(null !== resp){
                            this.qualificationForm.name=resp.name;
                            this.qualificationForm.url=resp.url;
                        }
                    });
                }
                this.qualificationDialog=true;
            },
            uploadQualification() {
                this.$refs.qualificationForm.validate((valid) => {
                    if (valid) {
                        addWorksQualification(this.qualificationForm).then(resp=>{
                            if (resp.success) {
                                this.qualificationDialog = false;
                                this.$message.success("提交成功");
                                this.getList();
                            }else{
                                this.$message.error(res.message);
                            }
                        });
                    }
                });
            },
            handleQualificationSuccess(file) {
                this.qualificationForm.name=file.name;
                this.qualificationForm.url=file.url;
            },
            downLoadCertificate(url,name){
                const x = new window.XMLHttpRequest();
                x.open('GET', url, true);
                x.responseType = "blob";
                x.onload = () =>{
                    const url = window.URL.createObjectURL(x.response);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = name;
                    a.click();
                };
                x.send();
            },
            timeDate(value){
                let date = new Date(value);
                let y = date.getFullYear();
                let MM = date.getMonth() + 1;
                MM = MM < 10 ? "0" + MM : MM;
                let d = date.getDate();
                d = d < 10 ? "0" + d : d;
                return y + "-" + MM + "-" + d;
            },
            // 编辑器内容更新
            editHomepageInput2(val){
                this.$refs.ruleForm.validateField('description')
            },
            handleProgress(){

            },
            //
            // 上传图片
            handleCoverSuccess(file){
                this.ruleForm.coverUrl = file.url;
            },
            handleWorksSuccess(file){
                // this.ruleForm.worksName = file.name;
                // this.ruleForm.worksUrl = file.url;
                this.ruleForm.worksFileList.push({name:file.name, url:file.url});
                console.log('this.ruleForm.worksFileList',this.ruleForm.worksFileList, file);
                this.$refs.ruleForm.validateField('worksFileList');
            },
            // 删除图片
            handleRemove(file,fileList) {
                this.ruleForm.worksFileList = fileList;
                /*if(this.ruleForm.worksFileList.length>0){
                    for(let i=0;i<this.ruleForm.worksFileList.length;i++){
                        if(this.ruleForm.worksFileList[i].uuid = file.uuid){
                            this.ruleForm.worksFileList.splice(i,1)
                        }
                    }
                }*/
            },
        }
    }
</script>

<style scoped lang="less">
.imgsMess {
    margin: 0;
    margin-left: 10px;
    color: #a1a1a1;
}
.orderManagementClass {
    position: relative;
    width: 100%;
    padding: 0 20px 20px;
    .orderManagementContent {
        background: #fff;
        .printOrderListBox {
            padding: 20px;
            .orderSearchBox {
                display: flex;
                flex-wrap: wrap;
                margin-bottom: 20px;

                /deep/ .el-input {
                    width: initial;
                    // margin-bottom: 22px;
                    margin-right: 30px;
                }

                /deep/ .el-input__inner {
                    width: 242px;
                    height: 35px;
                    min-height: 35px;
                    font-size: 12px;
                    color: #999999;
                    background-color: #f2f4f7;
                    border: 1px solid #f2f4f7;
                    border-radius: 5px;

                    &:hover,
                    &:focus {
                        background-color: #fff;
                        border: 1px solid #108ee9;
                    }
                }

                /deep/ .el-input__prefix {
                    top: -3px;
                }

                /deep/ .el-input__suffix {
                    top: 2px;
                }

                /deep/ .el-button {
                    display: block;
                    line-height: 35px;
                    padding: 0;
                    height: 35px;
                }

                .searchBtn {
                    width: 82px;
                    background: #3d7fff;
                    border: none;
                    border-radius: 15px;
                    font-size: 14px;
                    color: #ffffff;
                }

                .resetBtn {
                    color: #333333;
                }
                .searchItem {
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;

                    .name {
                        padding-right: 20px;
                        min-width: 100px;
                    }
                }
            }

            .tableContent {
                min-height: 650px;

                /deep/ .el-table__header {
                    tr {
                        th {
                            border-right: none;
                        }
                    }

                    /deep/ .el-table__cell {
                        padding: 5px 0;
                        background: #f2f5fc;
                    }
                }

                /deep/ .el-table__body {
                    img {
                        vertical-align: middle;
                        width: 52px;
                        height: 50px;
                    }
                }
            }

            .pagination {
                margin-top: 20px;
                text-align: right;
            }
            .orderListTable {
                margin-top: 35px;
            }
        }
    }
    .tableTool {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 20px;
        .toolRight {
            button {
                width: 83px;
                height: 30px;
                background: rgba(21, 126, 251, 1);
                border: none;
                border-radius: 15px;
                font-size: 13px;
                color: #fff;

                i {
                    padding-right: 5px;
                }

                &:hover {
                    background: #61a2f0;
                }
            }
        }
    }
    .dialogBox {
        .details {
            .detailsItem {
                padding-bottom: 20px;
                h3 {
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .itemContent {
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 15px;
                    padding: 0 30px;
                    .one-row {
                        width: 50%;
                        margin-bottom: 22px;
                        display: flex;
                        .label {
                            padding-right: 15px;
                            min-width: 95px;
                        }
                        .name {
                            color: #000;
                        }
                    }
                    .two-row {
                        width: 100%;
                        margin-bottom: 22px;
                        display: flex;
                        .label {
                            padding-right: 15px;
                            min-width: 95px;
                        }
                        .name {
                            color: #000;
                        }
                    }
                }
                .itemPictureContent {
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 15px;
                    padding: 0 30px;
                    justify-content: space-between;
                    .one-row {
                        width: 30%;
                        margin-bottom: 22px;
                        img {
                            width: 100%;
                            height: 138px;
                            border: 1px solid #ddd;
                        }
                        .name {
                            text-align: center;
                            padding-top: 10px;
                            font-size: 14px;
                            display: flex;
                            .label {
                                min-width: 80px;
                            }
                        }
                    }
                }
            }
        }
        .audit {
            padding-bottom: 20px;
            h3 {
                font-weight: 700;
                font-size: 16px;
                color: #000;
                margin-top: 0;
                letter-spacing: 1px;
                border-bottom: 1px solid #ddd;
                padding-bottom: 15px;
            }
            .auditContent {
                padding: 0 30px;
            }
            .cause {
                display: flex;
                margin-top: 20px;
                .causeTitle {
                    min-width: 80px;
                    color: #3a8ee6;
                }
                .causeContent {
                    color: #000;
                }
            }
            .auditEnter {
                text-align: center;
                padding-top: 20px;
                button {
                    width: 120px;
                }
            }
        }
    }
}
.sorting {
    p {
        margin: 0;
    }
    /deep/.el-radio-button--small .el-radio-button__inner {
        display: flex;
        align-items: center;
    }
    /deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: #3d7fff;
    }
}
.upload_imgbox {
    position: relative;
    width: 334px;
    height: 182px;
    background: rgba(244, 244, 244, 0.39);
    border: 1px solid #dddddd;
    border-radius: 4px;
    color: #157efb;
    .imgurl {
        width: 334px;
        height: 182px;
        border-radius: 4px;
        border: 1px solid #dddddd;
    }
    .upload_img {
        width: 334px;
        height: 182px;
        border-radius: 4px;
        border: 1px solid #dddddd;
    }
    .upload_imgboxText {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        line-height: 63px;
        font-size: 18px;
        i {
            font-size: 46px;
        }
    }
    /deep/.el-upload--picture-card {
        width: 334px;
        height: 182px;
        background: rgba(244, 244, 244, 0.39);
        border: 1px solid #dddddd;
        border-radius: 4px;
        color: #157efb;
    }
}
.clamp—one {
	white-space:nowrap;
	overflow:hidden;
	text-overflow:ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/views/active/activeJoin.vue